<template>
<span></span>
</template>

<script>
export default {
  name: 'EndpointTile',
  props: {
    device: {
      type: String,
      required: true
    },
    info: {
      type: Object,
      required: true
    },
    report: {
      type: Object
    },
    config: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    endpointId() {
      return (this.info || {}).id;
    }
  },
  methods: {
    showSettingsDialog() {
      this.$emit('setting', this.endpointId);
      this.dialog = false;
    }
  }
}
</script>
